import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { pick } from 'lodash';

// import { Link } from 'react-router-dom';
import {
  Modal,
  ModalBody
} from 'reactstrap';
import ModalHeader from '../reactstrap/ModalHeader';

import ProfileForm from './form';

import { updateProfileSuccess } from '../../actions';
import { User } from '../../api'


const mapStateToProps = state => ({ pixelSets: state.pixelSets, isLoading: state.loaders.pixelSets, currentUser: state.currentUser });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ updateProfileSuccess }, dispatch)
};



const modalPropKeys = Object.keys(Modal.propTypes);

class EditProfileModal extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      isDeleting: false,
    };
  }
  
  componentWillMount(nextProps) {
    // this.props.listPixelSets();
  }
  
  onSuccess(res) {
    const { updateProfileSuccess, toggle } = this.props; 
    updateProfileSuccess(res);
    toggle();
  }
  
  render() {
    const { toggle, currentUser, ...otherProps } = this.props;
    const modalProps = pick(otherProps, modalPropKeys);
    
    return (
      <Modal {...modalProps} centered={true}>
        <ModalHeader toggle={toggle}>Edit Profile</ModalHeader>
        <ModalBody>
          <ProfileForm initialValues={{...pick(currentUser, ['name', 'email'])}} onSubmit={User.update} onSuccess={this.onSuccess.bind(this)} />
        </ModalBody>
      </Modal>
    );
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(EditProfileModal);


// WEBPACK FOOTER //
// ./src/components/Profile/editModal.js